import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import './Business.js';
import { a as BusinessFormClickActions } from './event-types.js';
import { B as Button } from './button.js';
import './details.js';

const PaymentProvisioningFormButtons = /*@__PURE__*/ proxyCustomElement(class PaymentProvisioningFormButtons extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    get showPreviousStepButton() {
        return this.currentStep > 0;
    }
    get showNextStepButton() {
        return this.currentStep < this.totalSteps;
    }
    get showSubmitButton() {
        return this.currentStep === this.totalSteps;
    }
    render() {
        return (h("div", { key: '7c793a33752cd9b3dd1ebc6c30b7a98002ef8820', class: 'd-flex gap-2' }, h(Button, { key: '5127c233ef8c819fe17204baaff7370d78ec70e7', variant: "secondary", type: "button", onClick: () => this.previousStepButtonOnClick(), disabled: this.formDisabled, hidden: !this.showPreviousStepButton }, "Previous"), h(Button, { key: 'd889e96935718eb333eaac70023fd7b273118676', variant: "primary", type: "button", onClick: (e) => this.nextStepButtonOnClick(e, BusinessFormClickActions.nextStep), disabled: this.formDisabled, isLoading: this.formLoading, hidden: !this.showNextStepButton }, "Next"), h(Button, { key: '5502d7d73084119862451389bf85705407187016', variant: "primary", type: "submit", onClick: (e) => this.nextStepButtonOnClick(e, BusinessFormClickActions.submit), disabled: this.formDisabled, isLoading: this.formLoading, hidden: !this.showSubmitButton }, "Submit")));
    }
}, [0, "justifi-payment-provisioning-form-buttons", {
        "currentStep": [2, "current-step"],
        "totalSteps": [2, "total-steps"],
        "formLoading": [4, "form-loading"],
        "formDisabled": [4, "form-disabled"],
        "previousStepButtonOnClick": [16, "previous-step-button-on-click"],
        "nextStepButtonOnClick": [16, "next-step-button-on-click"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-payment-provisioning-form-buttons"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-payment-provisioning-form-buttons":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PaymentProvisioningFormButtons);
            }
            break;
    } });
}
defineCustomElement();

export { PaymentProvisioningFormButtons as P, defineCustomElement as d };
